import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const dashboardManagement = createApi({
    reducerPath: "dashboardManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        studentStatusInGroups: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/dashboard/student-status-in-groups`;

                for (const property in body) {
                    if (property && body[property]) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        groupsBelowMinimumStudents: builder.mutation({
            query: () => ({
                url: `v1/${locale}/dashboard/groups-below-minimum-students`,
                method: "GET",
            }),
        }),

        studentAbsence: builder.mutation({
            query: () => ({
                url: `v1/${locale}/dashboard/students-three-absences`,
                method: "GET",
            }),
        }),
    }),
});

export const { 
    useStudentStatusInGroupsMutation,
    useGroupsBelowMinimumStudentsMutation,
    useStudentAbsenceMutation
} = dashboardManagement;
